import { c as _c } from "react/compiler-runtime";
import clsx from 'clsx';
import { FC, HTMLAttributes } from 'react';
import BaseCard from '@/components/BaseCard';
import CardTags from '@/components/BaseCard/CardTags';
import { BlogPostDto } from '@/components/BlogPage/types';
import { Typography } from '@/components/shared/Typography';
import StrapiRichContent from '@/components/StrapiRichContent';
import { useBlogPost } from '@/hooks/blog/useBlogPost';
import css from './style.module.scss';
interface Props extends Omit<HTMLAttributes<HTMLAnchorElement>, 'title'> {
  post: BlogPostDto;
  showTags?: boolean;
  setIsCustomCursorVisible?: (value: boolean) => void;
}
const PostCard: FC<Props> = t0 => {
  const $ = _c(32);
  let className;
  let post;
  let rest;
  let setIsCustomCursorVisible;
  let t1;
  if ($[0] !== t0) {
    ({
      post,
      className,
      showTags: t1,
      setIsCustomCursorVisible,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = post;
    $[3] = rest;
    $[4] = setIsCustomCursorVisible;
    $[5] = t1;
  } else {
    className = $[1];
    post = $[2];
    rest = $[3];
    setIsCustomCursorVisible = $[4];
    t1 = $[5];
  }
  const showTags = t1 === undefined ? true : t1;
  const {
    cardTitle,
    media,
    isVideo,
    href
  } = useBlogPost(post);
  const t2 = isVideo ? media?.url : null;
  const t3 = isVideo ? null : media?.url;
  const t4 = Boolean(setIsCustomCursorVisible) && css.hideDefaultCursor;
  let t5;
  if ($[6] !== className || $[7] !== t4) {
    t5 = clsx(css.postCard, className, t4);
    $[6] = className;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== post.tags || $[10] !== showTags) {
    t6 = showTags ? <CardTags tags={post.tags.map(_temp)} /> : null;
    $[9] = post.tags;
    $[10] = showTags;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== cardTitle) {
    t7 = <h2 className={css.title}><StrapiRichContent content={cardTitle} /></h2>;
    $[12] = cardTitle;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== post.preview) {
    t8 = post.preview?.description ? <Typography variant="body-s" className={css.description}><StrapiRichContent content={post.preview.description} /></Typography> : null;
    $[14] = post.preview;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t7 || $[17] !== t8) {
    t9 = <>{t7}{t8}</>;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  let t11;
  if ($[19] !== setIsCustomCursorVisible) {
    t10 = () => setIsCustomCursorVisible?.(true);
    t11 = () => setIsCustomCursorVisible?.(false);
    $[19] = setIsCustomCursorVisible;
    $[20] = t10;
    $[21] = t11;
  } else {
    t10 = $[20];
    t11 = $[21];
  }
  let t12;
  if ($[22] !== href || $[23] !== rest || $[24] !== t10 || $[25] !== t11 || $[26] !== t2 || $[27] !== t3 || $[28] !== t5 || $[29] !== t6 || $[30] !== t9) {
    t12 = <BaseCard url={href} videoUrl={t2} imageUrl={t3} mediaClassName={css.media} withOverlay={false} className={t5} tags={t6} mainText={t9} onMouseEnter={t10} onMouseLeave={t11} {...rest} />;
    $[22] = href;
    $[23] = rest;
    $[24] = t10;
    $[25] = t11;
    $[26] = t2;
    $[27] = t3;
    $[28] = t5;
    $[29] = t6;
    $[30] = t9;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  return t12;
};
export default PostCard;
function _temp(tag) {
  return {
    id: tag.id,
    name: tag.name
  };
}